import { computed, ref } from 'vue'
import { QUOTE_RELANCE_LABELS, QUOTE_RELANCE_MAX_DAYS, QUOTE_RELANCE_MODES, QuoteRelanceMode } from '@shared/quote-relance.js'

/**
 * Choix « Programmer une relance » de l'aperçu du devis.
 *
 * Rien n'est programmé par défaut. Le choix n'est retenu qu'une fois confirmé
 * (« Programmer la relance ») et ne part qu'avec l'envoi du devis : les délais
 * se comptent depuis cet envoi. Aucun appel réseau ici (M10).
 */
export const QUOTE_RELANCE_OPTIONS = QUOTE_RELANCE_MODES.map((value) => ({
  value,
  label: QUOTE_RELANCE_LABELS[value],
  testId: `quote-relance-option-${value}`
}))

function localDayLabel(date) {
  const pad = (n) => String(n).padStart(2, '0')
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}

function dayLabelIn(days) {
  const d = new Date()
  d.setDate(d.getDate() + days)
  return localDayLabel(d)
}

export function frenchDate(label) {
  const [y, m, d] = label.split('-')
  return `${d}/${m}/${y}`
}

export function useQuoteRelanceChoice() {
  const mode = ref(null)
  const date = ref('')
  const error = ref('')
  const scheduled = ref(null)
  // Recalculée à chaque ouverture : une fiche restée ouverte passé minuit ne propose pas la veille.
  const minDate = ref(dayLabelIn(1))
  // Le devis part maintenant : au-delà, il serait déjà passé en perdu, relance comprise.
  const maxDate = ref(dayLabelIn(QUOTE_RELANCE_MAX_DAYS))

  function confirm() {
    error.value = ''
    if (!mode.value) return false
    if (mode.value === QuoteRelanceMode.DATE && (!date.value || date.value < minDate.value)) {
      error.value = 'Choisissez une date à venir.'
      return false
    }
    if (mode.value === QuoteRelanceMode.DATE && date.value > maxDate.value) {
      error.value = `Choisissez une date au plus tard le ${frenchDate(maxDate.value)}.`
      return false
    }
    scheduled.value = { mode: mode.value, date: mode.value === QuoteRelanceMode.DATE ? date.value : null }
    return true
  }

  function reset() {
    mode.value = null
    date.value = ''
    error.value = ''
    scheduled.value = null
    minDate.value = dayLabelIn(1)
    maxDate.value = dayLabelIn(QUOTE_RELANCE_MAX_DAYS)
  }

  const summary = computed(() => {
    const s = scheduled.value
    if (!s) return ''
    if (s.mode === QuoteRelanceMode.DATE) return `Relance programmée : le ${frenchDate(s.date)}`
    return `Relance programmée : ${QUOTE_RELANCE_LABELS[s.mode].toLowerCase()} après l'envoi`
  })

  return { mode, date, error, scheduled, minDate, maxDate, summary, confirm, reset }
}
